import React, { Fragment, useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogContent, IconButton, Snackbar } from '@mui/material';
import { Delete } from '@mui/icons-material';
import axios from 'axios';
import { useFormik } from 'formik';
import { testimonySchema } from '../schemas';
import { useSelector } from 'react-redux';

const NewTestimonies = ()=>{
    const uri = useSelector(state=>state.uri)
    const [testimonies, setTestimonies] = useState([])
    const [dialog, setDialog] = useState(false)
    const [error, setError] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [delDialog, setDelDialog] = useState(false)
    const [snackbarstatus, setSnackbarStatus] = useState(false)
    const [response, setResponse] = useState('')

    const {handleChange, handleBlur, handleSubmit, errors, touched} = useFormik({
        initialValues: {
            fullname: '',
            dept: '',
            level: '',
            testimony: ''
        },
        validationSchema: testimonySchema,
        onSubmit: (values)=>{
            if (values.fullname.split(' ')[1] !== undefined) {
                setIsSubmitting(true)
                axios.post(
                    `${uri}testimonies`,
                    values
                ).then(res=>{
                    setIsSubmitting(false)
                    fetchData()
                    setResponse(res.data.message)
                    setSnackbarStatus(true)
                    setDialog(false)
                }).catch(err=>{
                    setSnackbarStatus(true)
                    setResponse('An error has occured!')
                    setIsSubmitting(false)
                    console.log(err)
                })                
            } else {
                setResponse('Fullname must have both Firstname and Lastname')
                setSnackbarStatus(true)
            }
        }
    })

    useEffect(()=>{
        fetchData()
    }, [])

    const fetchData = ()=>{
        axios.get(
            `${uri}testimonies`
        ).then(res=>{
            setTestimonies(res.data.data)
            setIsLoading(false)
        }).catch(err=>{
            setIsLoading(false)
            setError(err.message)
        })
    }
    const deleteTestimony = (_id)=>{
        setDelDialog(true)
        axios.patch(
            `${uri}testimonies`,
            {_id}
        ).then(res=>{
            fetchData()
            setDelDialog(false)
            setSnackbarStatus(true)
            setResponse(res.data.message)
        }).catch((err)=>{
            setDelDialog(false)
            setSnackbarStatus(true)
            setResponse('An error occured!')
        })
    }
    const handleClose = (event, reason)=>{
        if (reason == 'clickaway') {
            return;
        }

        setSnackbarStatus(false)

    }

    return (
        <Fragment>
            <div className='container font-poppins mt-lg-0 mt-5 text-dark'>
                <p className='fw-bold-0 fs-4 text-dark pt-lg-0 pt-2'>
                    Testimonies
                </p>
                <p className='fs-6 text-danger'>
                    You can't add more than six (6) testimonies
                </p>
                <Button onClick={()=>setDialog(true)} className='bg-yrh text-white font-poppins fw-bold rounded-0 mb-3'>
                    Add
                </Button>
                {
                    isLoading
                    ?
                    <p className='text-info'>Waiting for server...</p>
                    :
                    testimonies.length !== 0
                    ?
                    <div className='row w-100 mx-auto my-4'>
                        {
                            testimonies.map((each, i)=>(
                                <div key={i} className='col-md-4 mb-4'>
                                    <div className='card testimony bg-yrh text-white px-3 pb-2 shadow'>
                                        <div className='d-flex justify-content-end'>
                                            <p className='pt-2'>- {each.fullname}</p>
                                        </div>
                                        <div className='testimony-body'>
                                            <p className='py-3'>
                                                {each.testimony}
                                            </p>
                                        </div>
                                        <div className='d-flex justify-content-end'>
                                            <IconButton onClick={()=>deleteTestimony(each._id)} className='text-danger'><Delete /></IconButton>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    :
                    testimonies.length == 0 && error == ''
                    ?
                    <p className='text-yrh fs-5'>Nothing is here...</p>
                    :
                    <p className='text-danger fs-5'>{error}</p>
                }
            </div>
            {/* Upload Modal */}
            <Dialog open={dialog} maxWidth={'xs'} fullWidth={true} className='font-poppins' >
                <DialogContent>
                    <p className='fs-6'>Add a Testimony </p>
                    <div className='my-4'>
                        <input type='text' onChange={handleChange} onBlur={handleBlur} name='fullname' className={errors.fullname && touched.fullname ? 'form-control is-invalid' : 'form-control'} placeholder='Full Name' />
                    </div>
                    <div className='my-4'>
                        <input type='text' className={errors.dept && touched.dept ? 'form-control is-invalid' : 'form-control'} name='dept' onChange={handleChange} onBlur={handleBlur} placeholder='Department' />
                    </div>
                    <div className='my-4'>
                        <input type='number' name='level' onChange={handleChange} onBlur={handleBlur} className={errors.level && touched.level ? 'form-control is-invalid' : 'form-control'} placeholder='Level' />
                    </div>
                    <div className='my-4'>
                        <textarea rows={5} name='testimony' onChange={handleChange} onBlur={handleBlur} placeholder="What's the testimony?" className={errors.testimony && touched.testimony ? 'form-control is-invalid' : 'form-control'} />
                    </div>
                    <Button disabled={isSubmitting} onClick={handleSubmit} className={isSubmitting ? 'border border-yrh text-yrh rounded-0 mx-1' : 'bg-yrh text-white rounded-0 mx-1'}>
                        {
                            isSubmitting
                            ?
                            'Adding...'
                            :
                            'Add'
                        }
                    </Button>
                    <Button disabled={isSubmitting} onClick={()=>setDialog(false)} className='bg-light text-dark rounded-0 mx-1'>
                        Cancel
                    </Button>
                </DialogContent>
            </Dialog>
            {/* Snackbar */}
            <Snackbar open={snackbarstatus} onClose={handleClose} autoHideDuration={5000} >
                <Alert severity={response.includes('successfully') ? 'success' : 'error'} onClose={handleClose}>
                    {response}
                </Alert>
            </Snackbar>
            {/* delete modal */}
            <Dialog open={delDialog} PaperProps={{
                style: {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                }
            }}
            >
                <DialogContent>
                    <p>
                        <span className='spinner-border text-white'></span>
                    </p>
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}

export default NewTestimonies